import { userService } from '@/_services';
import { twoFactorChallenge } from '@/_helpers';
import router from '@/router'

export default {

  login({ dispatch, commit }, { email, password, remember, aclChangeRole }) {
    commit('loginRequest', { email });

    return userService.login(email, password, aclChangeRole)
      .then(
        user => {
          // Contraseña correcta, falta el doble factor: configurarlo (SETUP) o capturar el código (VERIFY).
          // "Recordar por 30 días" viaja con el reto y se aplica al pasar el código.
          if (user.twoFactor) {
            commit('twoFactorRequired');
            twoFactorChallenge.save(Object.assign({}, user.twoFactor, { remember: !!remember }));
            router.push(user.twoFactor.status === 'SETUP' ? '/two-factor/setup' : '/two-factor');
            return Promise.resolve();
          }
          commit('loginSuccess', user);
          aclChangeRole(user.me.selected_company.role)
          router.push("/");
          return Promise.resolve();
        },
        error => {
          commit('loginFailure', error);
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      );
  },
  // Cierra el doble factor: authResponse es lo que devolvió la API al aceptar el código.
  twoFactorComplete({ dispatch, commit }, { authResponse, aclChangeRole }) {
    return userService.completeLogin(authResponse, aclChangeRole)
      .then(
        user => {
          twoFactorChallenge.clear();
          commit('loginSuccess', user);
          aclChangeRole(user.me.selected_company.role)
          router.push("/");
          return Promise.resolve();
        },
        error => {
          commit('loginFailure', error);
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      );
  },
  logout({ commit }) {
    userService.logout();
    commit('logout');
  },
  me({dispatch, commit}, {aclChangeRole}) {
    dispatch('alert/clear', {}, { root: true });
    return userService.refreshUserInfo(aclChangeRole)
      .then(
        user => {
          commit("loginSuccess", user)
          return Promise.resolve();
        },
        error => {
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      )
  },
  changeCompany({commit}, {company, role}) {
    userService.changeCompany(company, role);
    commit('changeCompany', company)
    location.reload()
  },
  smsVerification({dispatch, commit}, {phone}) {
    dispatch('alert/clear', {}, { root: true });
    return userService.smsVerification(phone)
      .then(
        () => {
          dispatch('alert/success', "Se envió correctamente el código de verificación", {root:true})
          return Promise.resolve();
        },
        error => {
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      )
  },
  smsVerificationCode({dispatch, commit}, {code, phone}) {
    dispatch('alert/clear', {}, { root: true });
    return userService.smsVerificationCode(code, phone)
      .then(
        () => {
          dispatch('alert/success', "Se realizó correctamente la verificación de teléfono", {root:true})
          return Promise.resolve();
        },
        error => {
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      )
  },
  changePassword({ commit, dispatch }, {currentPassword, newPassword, newPasswordConfirmation}) {
    commit('passwordChangeRequest');
    dispatch('alert/clear', "", { root: true });
    userService.changePassword(currentPassword, newPassword, newPasswordConfirmation)
      .then(
        success => {
          commit('passwordChangeSuccess')
          dispatch('alert/success', success.data, {root: true});
        },
        error => {
          commit('passwordChangeFailure')
          dispatch('alert/error', error, { root: true });
        }
      )
  },
  register({ dispatch, commit }, user) {
    commit('registerRequest', user);

    return userService.register(user)
      .then(
        user => {
          commit('registerSuccess', user);
          setTimeout(() => {
            // display success message after route change completes
            dispatch('alert/success', 'Registro realizado correctamente', { root: true });
          })
          return Promise.resolve();
        },
        error => {
          commit('registerFailure', error);
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      );
  },
  resend_verification_email({ dispatch, commit }, {email}) {
    return userService.resend_verification_email(email)
      .then(
        () => {
          dispatch('alert/success', 'El email se envió correctamente', { root: true });
          return Promise.resolve();
        },
        error => {
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      );
  },
  createPassword({ dispatch, commit }, {password, password_confirmation, token}) {
    dispatch('alert/clear', {}, { root: true });
    return userService.createPassword(password, password_confirmation, token)
      .then(
        () => {
          router.push('/login');
          setTimeout(() => {
            // display success message after route change completes
            dispatch('alert/success', 'Registro realizado correctamente', { root: true });
          })
          return Promise.resolve();
        },
        error => {
          dispatch('alert/error', error, { root: true });
          return Promise.reject();
        }
      );
  },
  accountActivation({dispatch, commit}, {uuid, hash}) {
    return userService.accountActivation(uuid, hash)
      .then(
        user => {
          router.push('/login')
          setTimeout(() => {
            // display success message after route change completes
            dispatch('alert/success', 'Su cuenta se ha activado con éxito', { root: true });
          })
        },
        error => {
          router.push('/login')
        }
      )
  },
  acceptInvitation({ dispatch, commit }, {name, password, password_confirmation, token}) {
    return userService.acceptInvitation(name, password, password_confirmation, token)
      .then(
        success => {
          router.push('/login');
          setTimeout(() => {
            dispatch('alert/success', 'Se ha completado el registro con éxito', { root: true });
          })
        },
        error => {
          return Promise.reject(error);
        }
      );
  },
  forgotPasswordRequest({ dispatch, commit }, {email}) {
    return userService.forgotPasswordRequest(email)
      .then(
        () => {
          router.push('/login');
          setTimeout(() => {
            dispatch('alert/success', 'Te hemos enviado un correo electronico con los pasos para restablecer tu contraseña', { root: true });
          })
          return Promise.resolve();
        },
        error => {
          dispatch('alert/error', error, {root:true})
          return Promise.reject(error);
        }
      );
  },
  forgotPassword({ dispatch, commit }, {password, password_confirmation, token}) {
    return userService.forgotPassword(password, password_confirmation, token)
      .then(
        () => {
          router.push('/login');
          setTimeout(() => {
            dispatch('alert/success', 'Has restablecido tu contraseña con éxito, ahora puedes iniciar sesión', { root: true });
          })
          return Promise.resolve();
        },
        error => {
          dispatch('alert/error', error, {root:true})
          return Promise.reject(error);
        }
      );
  },
  getApiKey({dispatch, commit}) {
    dispatch("alert/clear", {}, {root: true})
    return userService.getApiKey()
      .then(
        apiKey => {
          return Promise.resolve(apiKey);
        },
        error => {
          dispatch("alert/error", "Hubo un problema al obtener la API Key", {root: true})
          return Promise.reject(error);
        }
      )
  },
  resetApiKey({dispatch, commit}) {
    return userService.resetApiKey()
      .then(
        apiKey => {
          return Promise.resolve(apiKey);
        },
        error => {
          commit("setApiKey", "Hubo un problema al obtener la API Key")
          return Promise.reject(error);
        }
      )
  },
  getWebhookSecret({dispatch}) {
    return userService.getWebhookSecret()
      .then(
        webhookSecret => {
          return Promise.resolve(webhookSecret);
        },
        error => {
          dispatch("alert/error", "Hubo un problema al obtener la clave de webhooks", {root: true})
          return Promise.reject(error);
        }
      )
  },
  resetWebhookSecret({dispatch}) {
    return userService.resetWebhookSecret()
      .then(
        webhookSecret => {
          return Promise.resolve(webhookSecret);
        },
        error => {
          dispatch("alert/error", "Hubo un problema al regenerar la clave de webhooks", {root: true})
          return Promise.reject(error);
        }
      )
  },
  onBoardingQuestions({}, { data }) {
    return userService.onBoardingQuestions(data)
      .then(
        response => Promise.resolve(response),
        error => Promise.reject(error)
      )
  },
  getOnboardingPrefill() {
    return userService.getOnboardingPrefill()
      .then(
        response => Promise.resolve(response),
        error => Promise.reject(error)
      )
  },
  getDefaultSettings({}) {
    return userService.getDefaultSettings()
  },
  storeDefaultSettings({}, { data }) {
    return userService.storeDefaultSettings(data)
  }

}
